<template>
  <div class="registration-form-page">
    <header-pane :pageTitle="$tc('SignupPage.pageTitle')" colorType="light" />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'

/**
 * 新規会員登録
 */
export default defineComponent({
  name: 'RegistrationFormPage',
  components: {
    HeaderPane,
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.registration-form-page {
  background: #fff;
  min-height: var(--screen-height);
}
</style>
